/* PP — Canvas Design Studio (2026-07-15). Fabric.js layer over the existing design studio.
   Loads on /pages/design-studio via pp-designer-page.liquid. Zero changes to the studio's own
   logic: we listen to the same inputs and monkey-patch fetch('/cart/add.js') to attach the
   design JSON + rendered preview. Fabric is self-hosted on the shop CDN (CSP-safe). */
(function () {
  'use strict';
  var FABRIC_URL = 'https://cdn.shopify.com/s/files/1/0641/5102/7878/files/pp-fabric-5-3-0.js?v=1784147642';
  var root = document.getElementById('pp-ds');
  var stage = document.getElementById('pp-ds-canvas');
  var zoneEl = document.getElementById('pp-ds-zone');
  var fileInput = document.getElementById('pp-ds-file');
  var dropEl = document.getElementById('pp-ds-drop');
  if (!root || !stage || !zoneEl || !fileInput) return;

  /* ---------- self-heal: recover from a transient product-fetch failure ----------
     The studio fetches /products/<handle>.js once at load; if that request blips,
     it dead-ends at "PRODUCT UNAVAILABLE" with no retry. One silent reload recovers
     it (sessionStorage flag prevents a loop when a product is genuinely unavailable). */
  setTimeout(function () {
    var atc = document.getElementById('pp-ds-atc');
    var key = 'pp-ds-reload-' + (new URLSearchParams(location.search).get('product') || '');
    if (atc && /UNAVAILABLE/i.test(atc.textContent)) {
      if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); location.reload(); }
    } else {
      sessionStorage.removeItem(key);
    }
  }, 2600);

  var fab = null;            // fabric.Canvas
  var active = false;        // advanced editor on?
  var curSide = 'front';
  var sideJSON = { front: null, back: null, sleeve: null }; // saved layouts
  var fabricReady = null;    // promise
  var pendingImgs = [];      // image files uploaded (any time) not yet placed on canvas
  var placedKeys = {};       // file key -> true once placed
  var SLEEVE_ADDON_HANDLE = 'sleeve-print-add-on';
  function fileKey(f) { return f.name + '|' + f.size; }
  function isImgFile(f) { return /image\/(png|jpe?g|svg)/.test(f.type) || /\.(png|jpe?g|svg)$/i.test(f.name); }

  // Extra print locations — stackable add-ons (each becomes its own cart line at checkout)
  var EXTRAS = [
    { key: 'left sleeve', label: 'Left Sleeve', price: 3.00 },
    { key: 'right sleeve', label: 'Right Sleeve', price: 3.00 },
    { key: 'left chest', label: 'Left Chest', price: 3.00 },
    { key: 'pocket', label: 'Pocket', price: 3.00 },
    { key: 'back neck', label: 'Back Neck', price: 1.50 }
  ];
  var extrasOn = {};
  var extrasSummary = null;

  /* ---------- UI: toggle button + toolbar ---------- */
  var flipRow = root.querySelector('.pp-ds-flip');
  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.id = 'pp-fab-toggle';
  toggle.textContent = '✏️ Open Advanced Editor — drag, resize & add text';
  flipRow.parentNode.insertBefore(toggle, flipRow.nextSibling);

  var bar = document.createElement('div');
  bar.id = 'pp-fab-bar';
  bar.hidden = true;
  bar.innerHTML =
    "<button type='button' data-act='text'>➕ Add Text</button>" +
    "<select data-act='font' aria-label='Font'>" +
      "<option value='Inter, Arial, sans-serif'>Inter</option>" +
      "<option value='\"Arial Black\", Arial, sans-serif'>Arial Black</option>" +
      "<option value='Impact, Haettenschweiler, sans-serif'>Impact</option>" +
      "<option value='Georgia, serif'>Georgia</option>" +
      "<option value='\"Times New Roman\", serif'>Times</option>" +
      "<option value='\"Courier New\", monospace'>Courier</option>" +
      "<option value='\"Comic Sans MS\", cursive'>Comic</option>" +
    "</select>" +
    "<input type='color' value='#111111' data-act='color' aria-label='Text color'>" +
    "<button type='button' data-act='center'>Center</button>" +
    "<button type='button' data-act='up'>Layer ▲</button>" +
    "<button type='button' data-act='down'>Layer ▼</button>" +
    "<button type='button' data-act='del' class='danger'>🗑 Delete</button>" +
    "<button type='button' data-act='clear' class='danger'>Clear side</button>";
  toggle.parentNode.insertBefore(bar, toggle.nextSibling);

  var hint = document.createElement('div');
  hint.id = 'pp-fab-hint';
  hint.hidden = true;
  hint.textContent = 'Drag to move · corners to resize/rotate · double-tap text to edit. Art outside the dashed print area is trimmed automatically.';
  bar.parentNode.insertBefore(hint, bar.nextSibling);

  var toast = document.createElement('div');
  toast.id = 'pp-fab-toast';
  toast.hidden = true;
  bar.parentNode.insertBefore(toast, hint.nextSibling);
  var toastT = null;
  function showToast(msg) {
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 4200);
  }

  var css = document.createElement('style');
  css.textContent =
    '#pp-fab-toggle{width:100%;margin-top:10px;padding:12px;border:1.5px solid #0C85FD;background:#F0F7FE;color:#0A6FD0;border-radius:11px;font-weight:800;font-size:13px;cursor:pointer;transition:.15s}' +
    '#pp-fab-toggle:hover{background:#0C85FD;color:#fff}' +
    '#pp-fab-toggle.on{background:#0F2540;border-color:#0F2540;color:#fff}' +
    '#pp-fab-bar{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}' +
    '#pp-fab-bar button,#pp-fab-bar select{padding:9px 11px;border:1.5px solid #E5E8EB;background:#fff;border-radius:9px;font-weight:700;font-size:12px;cursor:pointer;font-family:inherit;min-height:38px}' +
    '#pp-fab-bar button:hover{border-color:#0C85FD;color:#0C85FD}' +
    '#pp-fab-bar .danger:hover{border-color:#DC2626;color:#DC2626}' +
    "#pp-fab-bar input[type='color']{width:44px;height:38px;padding:3px;border:1.5px solid #E5E8EB;border-radius:9px;background:#fff;cursor:pointer}" +
    '#pp-fab-hint{font-size:11px;color:#66738A;margin-top:8px;line-height:1.5}' +
    '#pp-fab-toast{margin-top:8px;background:#0F2540;color:#fff;font-size:12px;font-weight:700;padding:9px 13px;border-radius:9px}' +
    '#pp-fab-wrap{position:absolute;inset:18px;z-index:4}' +
    '#pp-fab-wrap canvas{border-radius:8px}' +
    '.pp-fab-active #pp-ds-zone img,.pp-fab-active #pp-ds-zone span{display:none!important}' +
    '#pp-ds-extras-ctl>label span{color:#66738A;text-transform:none;font-weight:600;font-size:11px;margin-left:2px}' +
    '.pp-ds-extras{display:grid;grid-template-columns:repeat(auto-fill,minmax(122px,1fr));gap:8px;max-width:660px}' +
    '.pp-ds-extras button{border:1.5px solid #E5E8EB;background:#fff;border-radius:11px;padding:10px 10px;cursor:pointer;text-align:left;transition:.13s;display:flex;flex-direction:column;gap:2px}' +
    '.pp-ds-extras button.on{border-color:#0C85FD;background:#F0F7FE;box-shadow:0 0 0 1px #0C85FD inset}' +
    '.pp-ds-extras .xl{font-weight:800;font-size:12.5px;color:#141922}' +
    '.pp-ds-extras .xp{font-size:11.5px;color:#0C85FD;font-weight:800}' +
    '.pp-ds-extras-sum{margin-top:12px;max-width:340px;background:#F7FAFD;border:1.5px solid #dfe8f2;border-radius:12px;padding:12px 14px}' +
    '.pp-ds-extras-sum .r{display:flex;justify-content:space-between;font-size:12.5px;color:#3A4552;padding:3px 0;font-variant-numeric:tabular-nums}' +
    '.pp-ds-extras-sum .r.tot{border-top:1px solid #dfe8f2;margin-top:4px;padding-top:8px;font-weight:900;color:#141922;font-size:13.5px}';
  document.head.appendChild(css);

  /* ---------- extra print locations: multi-select + live price ---------- */
  function extrasUnit() { var t = 0; EXTRAS.forEach(function (e) { if (extrasOn[e.key]) t += e.price; }); return t; }
  function garmentUnit() { var on = document.querySelector('#pp-ds-sides button.on .sp'); if (on) { var m = on.textContent.replace(/[^0-9.]/g, ''); if (m) return parseFloat(m) || 0; } return 0; }
  function qtyNow() { var q = parseInt((document.getElementById('pp-ds-qn') || {}).value, 10); return Math.max(1, q || 1); }
  function renderExtras() {
    var xu = extrasUnit(), gu = garmentUnit(), q = qtyNow();
    root.querySelectorAll('#pp-ds-extras button').forEach(function (b) { b.classList.toggle('on', !!extrasOn[b.dataset.k]); });
    if (extrasSummary) {
      if (xu > 0) {
        var rows = "<div class='r'><span>Garment</span><span>$" + gu.toFixed(2) + "</span></div>";
        EXTRAS.forEach(function (e) { if (extrasOn[e.key]) rows += "<div class='r'><span>+ " + e.label + " print</span><span>$" + e.price.toFixed(2) + "</span></div>"; });
        rows += "<div class='r tot'><span>Per piece</span><span>$" + (gu + xu).toFixed(2) + "</span></div>";
        extrasSummary.innerHTML = rows; extrasSummary.hidden = false;
      } else { extrasSummary.hidden = true; extrasSummary.innerHTML = ''; }
    }
    var atc = document.getElementById('pp-ds-atc');
    if (atc && gu > 0 && !/ADDING|UNAVAILABLE/i.test(atc.textContent)) {
      atc.textContent = 'ADD TO CART — $' + ((gu + xu) * q).toFixed(2);
    }
  }
  function buildExtras() {
    var placesEl = document.getElementById('pp-ds-places');
    var step4 = placesEl ? placesEl.closest('.pp-ds-ctl') : null;
    var ctl = document.createElement('div'); ctl.className = 'pp-ds-ctl'; ctl.id = 'pp-ds-extras-ctl';
    ctl.innerHTML = "<label>➕ Add Extra Print Locations <span>optional — stack as many as you like</span></label>" +
      "<div class='pp-ds-extras' id='pp-ds-extras'></div>" +
      "<div class='pp-ds-extras-sum' id='pp-ds-extras-sum' hidden></div>";
    if (step4 && step4.parentNode) step4.parentNode.insertBefore(ctl, step4.nextSibling);
    else root.querySelector('.pp-ds-right').appendChild(ctl);
    var wrap = ctl.querySelector('#pp-ds-extras');
    EXTRAS.forEach(function (e) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.k = e.key;
      b.innerHTML = "<span class='xl'>" + e.label + "</span><span class='xp'>+$" + e.price.toFixed(2) + "</span>";
      b.addEventListener('click', function () { extrasOn[e.key] = !extrasOn[e.key]; renderExtras(); });
      wrap.appendChild(b);
    });
    extrasSummary = ctl.querySelector('#pp-ds-extras-sum');
    var sidesEl = document.getElementById('pp-ds-sides');
    if (sidesEl) sidesEl.addEventListener('click', function () { setTimeout(renderExtras, 0); });
    ['pp-ds-qminus', 'pp-ds-qplus', 'pp-ds-qn'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.addEventListener('click', function () { setTimeout(renderExtras, 0); }); el.addEventListener('change', function () { setTimeout(renderExtras, 0); }); }
    });
    setTimeout(renderExtras, 1600); // once the product/variants have loaded
  }
  buildExtras();

  /* ---------- fabric loader ---------- */
  function loadFabric() {
    if (fabricReady) return fabricReady;
    fabricReady = new Promise(function (res, rej) {
      if (window.fabric) return res();
      var s = document.createElement('script');
      s.src = FABRIC_URL;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error('fabric load failed')); };
      document.head.appendChild(s);
    });
    return fabricReady;
  }

  /* ---------- geometry ---------- */
  function stageBox() { // inner box of the stage (padding 18px)
    var r = stage.getBoundingClientRect();
    return { w: Math.max(50, r.width - 36), h: Math.max(50, r.height - 36) };
  }
  function zoneRect() { // print-safe area in canvas px, from the zone element's % styles
    var b = stageBox();
    var l = parseFloat(zoneEl.style.left) || 30, t = parseFloat(zoneEl.style.top) || 33;
    var w = parseFloat(zoneEl.style.width) || 40, h = parseFloat(zoneEl.style.height) || 33;
    // zone % values are relative to the stage INCLUDING padding
    var full = stage.getBoundingClientRect();
    return {
      left: full.width * l / 100 - 18,
      top: full.height * t / 100 - 18,
      width: full.width * w / 100,
      height: full.height * h / 100
    };
  }
  function applyClip() {
    if (!fab || !window.fabric) return;
    var z = zoneRect();
    fab.clipPath = new fabric.Rect({ left: z.left, top: z.top, width: z.width, height: z.height, absolutePositioned: true });
    fab.requestRenderAll();
  }

  /* ---------- canvas lifecycle ---------- */
  function buildCanvas() {
    var b = stageBox();
    var wrap = document.createElement('div');
    wrap.id = 'pp-fab-wrap';
    var c = document.createElement('canvas');
    c.id = 'pp-fab-c';
    wrap.appendChild(c);
    stage.appendChild(wrap);
    fab = new fabric.Canvas(c, { width: b.w, height: b.h, selection: true, preserveObjectStacking: true });
    fabric.Object.prototype.set({
      transparentCorners: false, cornerColor: '#0C85FD', cornerStrokeColor: '#fff',
      borderColor: '#0C85FD', cornerSize: 12, touchCornerSize: 26, cornerStyle: 'circle', borderScaleFactor: 1.6
    });
    fab.on('object:removed', function () { setTimeout(syncVariant, 30); });
    fab.on('object:added', function () { fab.renderAll(); });
    applyClip();
    window.addEventListener('resize', debounce(function () {
      if (!fab) return;
      var nb = stageBox();
      fab.setDimensions({ width: nb.w, height: nb.h });
      applyClip();
    }, 200));
  }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function saveSide() { if (fab) sideJSON[curSide] = fab.toJSON(); }
  function loadSide(side) {
    curSide = side;
    if (!fab) return;
    if (sideJSON[side]) fab.loadFromJSON(sideJSON[side], function () { applyClip(); fab.requestRenderAll(); });
    else { fab.clear(); applyClip(); }
  }

  /* ---------- price sync: designed sides drive the Print Sides variant ---------- */
  function sideHasArt(s) {
    if (s === curSide && fab) return fab.getObjects().length > 0;
    var j = sideJSON[s];
    return !!(j && j.objects && j.objects.length);
  }
  function syncVariant() {
    if (!active) return;
    saveSide();
    // sleeve art in the editor → auto-add the sleeve extra so it gets priced
    if (sideHasArt('sleeve') && !extrasOn['left sleeve'] && !extrasOn['right sleeve']) { extrasOn['left sleeve'] = true; renderExtras(); }
    var f = sideHasArt('front'), b = sideHasArt('back');
    if (!f && !b) return; // nothing designed on body yet — leave the customer's choice alone
    var want = (f && b) ? 'both' : (b ? 'back' : 'front');
    var btns = document.querySelectorAll('#pp-ds-sides button');
    var target = null;
    btns.forEach(function (x) {
      var t = (x.querySelector('.st') ? x.querySelector('.st').textContent : x.textContent).toLowerCase();
      var isBoth = t.indexOf('front') > -1 && t.indexOf('back') > -1;
      if (want === 'both' && isBoth) target = x;
      if (want === 'back' && !isBoth && t.indexOf('back') > -1) target = x;
      if (want === 'front' && !isBoth && t.indexOf('front') > -1) target = x;
    });
    if (target && !target.classList.contains('on') && !target.disabled) {
      target.click();
      var priceEl = target.querySelector('.sp');
      showToast('Price updated — ' + (want === 'both' ? 'front + back print' : want + ' print') + (priceEl ? ' (' + priceEl.textContent + ' each)' : '') + (sideHasArt('sleeve') ? ' · sleeve print +$3.00 added at cart' : ''));
    } else if (sideHasArt('sleeve')) {
      showToast('Sleeve print +$3.00 per piece — added automatically at cart.');
    }
  }

  /* ---------- tools ---------- */
  function addText() {
    if (!fab) return;
    var z = zoneRect();
    var t = new fabric.IText('YOUR TEXT', {
      left: z.left + z.width / 2, top: z.top + z.height / 2,
      originX: 'center', originY: 'center',
      fontFamily: bar.querySelector("[data-act='font']").value,
      fill: bar.querySelector("[data-act='color']").value,
      fontSize: Math.max(20, Math.round(z.width / 7)), fontWeight: '800', textAlign: 'center'
    });
    fab.add(t); fab.setActiveObject(t); t.enterEditing(); t.selectAll(); fab.renderAll();
    syncVariant();
  }
  function addImageFile(f) {
    if (!fab || !isImgFile(f)) return;
    if (placedKeys[fileKey(f)]) return; // already on a canvas side
    placedKeys[fileKey(f)] = true;
    var url = URL.createObjectURL(f);
    fabric.Image.fromURL(url, function (img) {
      var z = zoneRect();
      var sc = Math.min(z.width / img.width, z.height / img.height) * 0.9;
      img.set({ left: z.left + z.width / 2, top: z.top + z.height / 2, originX: 'center', originY: 'center', scaleX: sc, scaleY: sc });
      img.ppName = f.name;
      fab.add(img); fab.setActiveObject(img); fab.renderAll();
      syncVariant();
    }, { crossOrigin: 'anonymous' });
  }
  function recordFiles(fl) { // remember every image upload, whenever it happens
    Array.prototype.slice.call(fl).forEach(function (f) {
      if (isImgFile(f) && !placedKeys[fileKey(f)] && !pendingImgs.some(function (p) { return fileKey(p) === fileKey(f); })) pendingImgs.push(f);
    });
  }
  function importPending() { // place any earlier uploads onto the canvas
    if (!fab) return;
    var todo = pendingImgs.filter(function (f) { return !placedKeys[fileKey(f)]; });
    pendingImgs = [];
    todo.forEach(addImageFile);
    if (todo.length) showToast(todo.length + (todo.length > 1 ? ' uploads' : ' upload') + ' placed on the mockup — drag to arrange.');
  }
  bar.addEventListener('click', function (e) {
    var act = e.target.getAttribute('data-act'); if (!act || !fab) return;
    var o = fab.getActiveObject();
    if (act === 'text') addText();
    if (act === 'del' && o) { fab.remove(o); fab.discardActiveObject(); fab.requestRenderAll(); }
    if (act === 'center' && o) { var z = zoneRect(); o.set({ left: z.left + z.width / 2, top: z.top + z.height / 2, originX: 'center', originY: 'center' }); o.setCoords(); fab.requestRenderAll(); }
    if (act === 'up' && o) { fab.bringForward(o); fab.requestRenderAll(); }
    if (act === 'down' && o) { fab.sendBackwards(o); fab.requestRenderAll(); }
    if (act === 'clear') { fab.clear(); applyClip(); }
  });
  bar.addEventListener('change', function (e) {
    var act = e.target.getAttribute('data-act'); if (!fab) return;
    var o = fab.getActiveObject();
    if (o && o.type === 'i-text') {
      if (act === 'font') o.set('fontFamily', e.target.value);
      if (act === 'color') o.set('fill', e.target.value);
      fab.requestRenderAll();
    }
  });

  /* ---------- hook the existing studio (no code changes there) ----------
     Document-level CAPTURE listeners: they fire BEFORE the studio's own handlers,
     which clear the file input (fileInput.value='') right after reading it. */
  function takeFiles(fl) {
    var arr = Array.prototype.slice.call(fl);
    if (active) arr.forEach(addImageFile); else recordFiles(arr);
  }
  document.addEventListener('change', function (e) {
    if (e.target === fileInput && fileInput.files && fileInput.files.length) takeFiles(fileInput.files);
  }, true);
  document.addEventListener('drop', function (e) {
    if (dropEl && dropEl.contains(e.target) && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) takeFiles(e.dataTransfer.files);
  }, true);
  root.querySelectorAll('.pp-ds-flip button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!active) return;
      saveSide();
      setTimeout(function () { loadSide(b.dataset.side); applyClip(); }, 60);
    });
  });
  var places = document.getElementById('pp-ds-places');
  if (places) places.addEventListener('click', function () {
    if (active) setTimeout(applyClip, 60); // zone element just moved
  });
  // Step 4 = your primary (included) print location; all upcharges now live in the
  // "Add Extra Print Locations" block, so strip any "+$" from the step-4 chips.
  if (places) setTimeout(function () {
    places.querySelectorAll('button').forEach(function (b) {
      var ps = b.querySelector('.ps'); if (ps) ps.textContent = ps.textContent.replace(/\s*[·]?\s*\+\$[0-9.]+/, '');
    });
  }, 150);

  /* ---------- toggle ---------- */
  toggle.addEventListener('click', function () {
    if (!active) {
      toggle.disabled = true; toggle.textContent = 'Loading editor…';
      loadFabric().then(function () {
        if (!fab) buildCanvas();
        active = true; window.__ppFabActive = true;
        root.classList.add('pp-fab-active');
        bar.hidden = false; hint.hidden = false;
        toggle.disabled = false; toggle.classList.add('on');
        toggle.textContent = '✕ Close Advanced Editor (design is kept)';
        loadSide(curSide);
        setTimeout(importPending, 250); // place any art uploaded before the editor was opened
      }).catch(function () {
        toggle.disabled = false;
        toggle.textContent = '✏️ Open Advanced Editor — drag, resize & add text';
        alert('The editor could not load — you can still upload your art normally and we will place it for you.');
      });
    } else {
      saveSide();
      active = false; window.__ppFabActive = false;
      root.classList.remove('pp-fab-active');
      bar.hidden = true; hint.hidden = true;
      toggle.classList.remove('on');
      toggle.textContent = '✏️ Open Advanced Editor — drag, resize & add text';
      var wrap = document.getElementById('pp-fab-wrap');
      if (wrap) wrap.style.display = 'none';
      return;
    }
    var wrap = document.getElementById('pp-fab-wrap');
    if (wrap) wrap.style.display = '';
  });

  /* ---------- attach design to the order (fetch interceptor) ---------- */
  function dataURLtoBlob(du) {
    var p = du.split(','), mime = p[0].match(/:(.*?);/)[1], bin = atob(p[1]), n = bin.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bin.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }
  function compactJSON() {
    saveSide();
    var out = { product: new URLSearchParams(location.search).get('product') || '', sides: {} };
    ['front', 'back', 'sleeve'].forEach(function (s) {
      var j = sideJSON[s];
      if (j && j.objects && j.objects.length) {
        out.sides[s] = j.objects.map(function (o) {
          return {
            type: o.type, file: o.ppName || undefined, text: o.text || undefined,
            font: o.fontFamily || undefined, fill: o.fill || undefined,
            left: Math.round(o.left), top: Math.round(o.top),
            scaleX: +(o.scaleX || 1).toFixed(3), scaleY: +(o.scaleY || 1).toFixed(3),
            angle: Math.round(o.angle || 0)
          };
        });
      }
    });
    return JSON.stringify(out);
  }
  function previewBlob() {
    if (!fab) return null;
    saveSide();
    var withArt = ['front', 'back', 'sleeve'].filter(function (s) { return sideJSON[s] && sideJSON[s].objects && sideJSON[s].objects.length; });
    if (!withArt.length) return Promise.resolve(null);
    // render each side sequentially into one wide composite
    var W = fab.getWidth(), H = fab.getHeight();
    var comp = document.createElement('canvas');
    comp.width = W * withArt.length; comp.height = H + 26;
    var ctx = comp.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, comp.width, comp.height);
    var restore = curSide;
    var chain = Promise.resolve();
    withArt.forEach(function (s, i) {
      chain = chain.then(function () {
        return new Promise(function (res) {
          fab.loadFromJSON(sideJSON[s] || { objects: [] }, function () {
            fab.discardActiveObject(); applyClip(); fab.renderAll();
            var img = new Image();
            img.onload = function () {
              ctx.drawImage(img, W * i, 26);
              ctx.fillStyle = '#111'; ctx.font = 'bold 15px Inter, Arial';
              ctx.fillText(s.toUpperCase(), W * i + 8, 18);
              res();
            };
            img.src = fab.toDataURL({ format: 'png' });
          });
        });
      });
    });
    return chain.then(function () {
      return new Promise(function (res) {
        fab.loadFromJSON(sideJSON[restore] || { objects: [] }, function () { applyClip(); fab.renderAll(); res(dataURLtoBlob(comp.toDataURL('image/png'))); });
      });
    });
  }
  function addExtras(qty) {
    var chosen = EXTRAS.filter(function (e) { return extrasOn[e.key]; });
    if (!chosen.length) return Promise.resolve();
    return _fetch('/products/' + SLEEVE_ADDON_HANDLE + '.js')
      .then(function (r) { if (!r.ok) throw new Error('addon nf'); return r.json(); })
      .then(function (p) {
        // add each chosen extra as its own cart line, sequentially (avoids cart races)
        var chain = Promise.resolve();
        chosen.forEach(function (e) {
          var v = null;
          p.variants.forEach(function (x) { if (!v && x.title.toLowerCase().indexOf(e.key) > -1) v = x; });
          if (!v) return;
          chain = chain.then(function () {
            var fd2 = new FormData();
            fd2.append('id', v.id);
            fd2.append('quantity', qty || 1);
            fd2.append('properties[Add-On]', e.label + ' print — matches garment quantity');
            return _fetch('/cart/add.js', { method: 'POST', body: fd2 });
          });
        });
        return chain;
      })
      .catch(function () { /* fail-soft: staff sees the design/placement on the order and can invoice */ });
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add.js') > -1 && init && init.body instanceof FormData && !init.body.get('properties[Add-On]')) {
      var fd = init.body;
      var args = arguments;
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      var pre = (window.__ppFabActive && fab) ? Promise.resolve(previewBlob()) : Promise.resolve(null);
      return pre.then(function (blob) {
        try {
          if (window.__ppFabActive && fab) {
            fd.append('properties[Advanced Editor]', 'Yes — layout attached');
            fd.append('properties[_Design Layout]', compactJSON());
            if (blob) fd.append('properties[Design Preview]', blob, 'design-preview.png');
          }
        } catch (e) { /* never block checkout */ }
        return _fetch.apply(window, args).then(function (resp) {
          if (resp && resp.ok) return addExtras(qty).then(function () { return resp; });
          return resp;
        });
      }).catch(function () { return _fetch.apply(window, args); });
    }
    return _fetch.apply(window, arguments);
  };
})();

/* a11y/SEO: the studio page renders no h1 — insert a visually-hidden one */
(function () {
  try {
    if (location.pathname.indexOf('/pages/design-studio') === -1) return;
    if (document.querySelector('h1')) return;
    var m = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    var h = document.createElement('h1');
    h.textContent = 'Custom Apparel Design Studio';
    h.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
    m.insertBefore(h, m.firstChild);
  } catch (e) {}
})();
